export default function BenefitsNewZealandStudentVisa() {
    return (
        <section className="w-full pb-16 px-4 sm:px-6 lg:px-16 bg-white">
            <div className="max-w-7xl mx-auto flex flex-col gap-8">

                {/* Main Heading */}
                <h3 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900">
                    Benefits of New Zealand Student Visa Consultants
                </h3>

                <div className="text-justify space-y-4 text-gray-800 text-base sm:text-lg lg:text-xxl leading-relaxed">
                    <p>
                        Planning to study abroad can be complex without proper guidance. 
                        Professional New Zealand Student Visa Consultants help students navigate 
                        the entire process smoothly — from course selection to visa approval. 
                        Their expertise minimizes errors, avoids delays, and significantly reduces 
                        the risk of visa rejection.
                    </p>
                </div>

                {/* University Admission */}
                <h4 className="text-xl sm:text-xl lg:text-2xl font-bold text-gray-900">
                    University Admission Assistance
                </h4>

                <div className="text-justify space-y-4 text-gray-800 text-base sm:text-lg lg:text-xxl leading-relaxed">
                    <p>
                        Education consultants assist students in selecting institutions and 
                        programs aligned with their academic background and career goals. 
                        They review academic profiles, prepare strong applications, 
                        ensure documentation meets university standards, and monitor 
                        application timelines — increasing the chances of admission approval.
                    </p>
                </div>

                {/* Offer of Place */}
                <h4 className="text-xl sm:text-xl lg:text-2xl font-bold text-gray-900">
                    Offer of Place Documentation Support
                </h4>

                <div className="text-justify space-y-4 text-gray-800 text-base sm:text-lg lg:text-xxl leading-relaxed">
                    <p>
                        Consultants guide students through accepting the Offer of Place, 
                        submitting required documentation, meeting institutional deadlines, 
                        and coordinating fee payments. A streamlined process ensures 
                        timely confirmation of enrollment and smooth visa processing.
                    </p>
                </div>

                {/* Insurance */}
                <h4 className="text-xl sm:text-xl lg:text-2xl font-bold text-gray-900">
                    Health & Travel Insurance Assistance
                </h4>

                <div className="text-justify space-y-4 text-gray-800 text-base sm:text-lg lg:text-xxl leading-relaxed">
                    <p>
                        Health insurance is mandatory for international students in New Zealand. 
                        Consultants explain insurance requirements, compare suitable providers, 
                        and help select plans based on duration and budget. 
                        This ensures students remain compliant throughout their stay.
                    </p>
                </div>

                {/* Scholarship */}
                <h4 className="text-xl sm:text-xl lg:text-2xl font-bold text-gray-900">
                    Scholarship Assistance
                </h4>

                <div className="text-justify space-y-4 text-gray-800 text-base sm:text-lg lg:text-xxl leading-relaxed">
                    <p>
                        Consultants evaluate academic achievements and identify suitable 
                        scholarship opportunities for undergraduate, postgraduate, PhD, 
                        and short-term training programs. This support increases the 
                        likelihood of securing financial aid and reducing overall study costs.
                    </p>
                </div>

                {/* Local Insights */}
                <h4 className="text-xl sm:text-xl lg:text-2xl font-bold text-gray-900">
                    Local Insights & Career Guidance
                </h4>

                <div className="text-justify space-y-4 text-gray-800 text-base sm:text-lg lg:text-xxl leading-relaxed">
                    <p>
                        Professional consultants provide valuable insights into regional 
                        employment markets, trending courses, part-time work opportunities, 
                        and cultural norms. This guidance helps students adapt quickly 
                        and maximize their academic and professional experience.
                    </p>
                </div>

                {/* Why Choose Shivasya */}
                <h3 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mt-6">
                    Why Choose Shivasya as Your New Zealand Student Visa Consultant?
                </h3>

                <div className="text-justify space-y-4 text-gray-800 text-base sm:text-lg lg:text-xxl leading-relaxed">
                    <p>
                        Securing a student visa requires a thorough understanding of immigration 
                        rules and compliance standards. Shivasya provides expert guidance to ensure 
                        accurate documentation, timely submissions, and reduced risk of visa rejection.
                    </p>

                    <p>
                        We assist students in selecting NZQA-recognized institutions, 
                        provide clarity on post-study work opportunities, and ensure 
                        full compliance with New Zealand immigration laws. 
                        Our proactive approach minimizes delays and supports students 
                        from application to post-arrival planning.
                    </p>

                    <p className="font-semibold text-gray-900">
                        Begin your Study Abroad journey to New Zealand with confidence. 
                        Contact Shivasya today and take the first step toward building 
                        a successful career in one of the world’s most desirable 
                        education destinations.
                    </p>
                </div>

            </div>
        </section>
    );
}